import { useEffect, useState } from "react";
import { fetchIdols, IDOL_PAGE_SIZE } from "./api";
import { useT } from "./i18n";
import type { Idol } from "./idol";

/**
 * 整份 idol 名册——给「所属 idol」这类**绑定**下拉用。
 *
 * **不筛 status**：绑定表达的是「这包卡属于谁」，跟她此刻是否在架无关。
 * 只列在架的话，下架期间打开一个已绑定的包，下拉里找不到她，看起来像绑定丢了。
 * （拼图页相反，只列在架的——新建内容给下架的人会在发布闸被拦，理由见 PuzzlePage。）
 *
 * 要翻完所有页，不能只取第一页：名册不设人数上限，第 201 位得进得了下拉。
 * 页数上限只是防失控的兜底，真被顶到时要说出来，不能静默截断。
 *
 * `enabled=false` 时不发请求（物品卡页用不到名册，别白打一轮接口）。
 */
export function useIdolRoster(enabled = true): { idols: Idol[]; error: string | null } {
  const t = useT();
  const [idols, setIdols] = useState<Idol[]>([]);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    void (async () => {
      try {
        const all: Idol[] = [];
        for (let page = 1; page <= 20; page++) {
          const r = await fetchIdols({ page });
          all.push(...r.idols);
          if (all.length >= r.total || r.idols.length < IDOL_PAGE_SIZE) break;
          if (page === 20 && alive) setError(t("pz.idolTruncated", { n: all.length, total: r.total }));
        }
        if (alive) setIdols(all);
      } catch (e) {
        if (alive) setError((e as Error).message);
      }
    })();
    return () => { alive = false; };
  }, [enabled, t]);
  return { idols, error };
}
